import { useItemApi } from '../../hooks/useSampleApi'
import LoadInView from '../common/LoadInView'
import { TableWrapper, Table } from '../common/Table'

interface itemType {
  stage: string
  stage_desc: string
  section: string
  item: string
  item_desc: string
}

const ViewAllQuiz = () => {
  const { isLoading, data } = useItemApi()
  
  if (isLoading) {
    return(
      <div>
        <h1>
          Loading...
        </h1>
      </div>
    )
  } else {
    return (
      <div>
        <h1>검사도구팀</h1>
        <LoadInView>
          <TableWrapper>
            <Table>
              <colgroup>
                <col width="5%"/>
                <col width="10%"/>
                <col width="10%"/>
                <col width="20%"/>
                <col width="55%"/>
              </colgroup>
              <thead>
                <tr>
                  <th>단계</th>
                  <th>단계_설명</th>
                  <th>영역</th>
                  <th>문항</th>
                  <th>문항설명</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((iTem: itemType, index: number) => (
                  <tr key={index}>
                    <td key={iTem.stage}>{iTem.stage}</td>
                    <td key={iTem.stage_desc}>{iTem.stage_desc}</td>
                    <td key={iTem.section}>{iTem.section}</td>
                    <td key={iTem.item}>{iTem.item}</td>
                    <td key={iTem.item_desc}>{iTem.item_desc}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </TableWrapper>
        </LoadInView>
      </div>
    )
  }
}

export default ViewAllQuiz